module.exports = __webpack_public_path__ + "img/bell.f9c1f994.svg";